module.exports = __webpack_public_path__ + "static/media/bi.3f52178a.svg";